import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appCurrency',
})
export class AppCurrencyPipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): any {
    let str = value?.toString();
    let base,
      dec = '';
    if (str && str.includes('.')) {
      str = Number(str).toFixed(2);
      base = this.separator(str.split('.')[0]);
      dec = str.split('.')[1];
    } else {
      base = this.separator(str);
      dec = '00';
    }
    return '$' + base + '.' + dec;
  }

  separator = (str: string): any => {
    if(!str) return '';
    if (str.length <= 3) return str;
    return (
      this.separator(str.substring(0, str.length - 3)) +
      ',' +
      str.slice(str.length - 3)
    );
  };
}
